// pages/PaymentCancel.jsx
import React from 'react';
import { CloseCircleTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #fffbe7 0%, #ffe0b2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 8px 32px #ff980033',
          width: 400,
          maxWidth: '95vw',
          padding: 32,
          border: '1.5px solid #ffe0b2',
          fontFamily: 'Montserrat, Arial, sans-serif',
          textAlign: 'center',
        }}
      >
        <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 48, marginBottom: 12 }} />
        <h2 style={{ color: '#d32f2f', fontWeight: 700, marginBottom: 12 }}>
          Thanh toán đã bị huỷ
        </h2>
        <p style={{ color: '#888', fontSize: 16, marginBottom: 28 }}>
          Bạn đã huỷ thanh toán. Vui lòng thử lại nếu cần.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            background: '#FF9800',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '10px 28px',
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
            boxShadow: '0 2px 8px #ff980033',
            transition: 'background 0.2s',
          }}
        >
          Về trang chủ
        </button>
      </div>
    </div>
  );
}

export default PaymentCancel;
